module.exports = __webpack_public_path__ + "img/floor-plan-preview.f92e1c6c.svg";